import { render, staticRenderFns } from "./Leave-Update-Engineer.vue?vue&type=template&id=487ff42b"
import script from "./Leave-Update-Engineer.vue?vue&type=script&lang=js"
export * from "./Leave-Update-Engineer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports